var map = {
	"./ADA_icon.png": "68dd",
	"./ALGO_icon.png": "d153",
	"./AVAX_icon.png": "963e",
	"./BNB_icon.png": "af93",
	"./BTC_icon.png": "4eda",
	"./CAKE_icon.png": "69a0",
	"./CRV_icon.png": "5153",
	"./DOT_icon.png": "92f6",
	"./ETH_icon.png": "b791",
	"./LINK_icon.png": "262f",
	"./LUNA_icon.png": "f4d4",
	"./MATIC_icon.png": "7720",
	"./MBOX_icon.png": "93de",
	"./SOL_icon.png": "21c2",
	"./TRX_icon.png": "0396",
	"./TUSD_icon.png": "8edf",
	"./XRP_icon.png": "8386"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f499";